import React from 'react'
import { Field as FormikField } from 'formik'
import styled from 'styled-components/macro'

export default function Field({ id, name, label, image }) {
  return (
    <FormikField name={name}>
      {({ field }) => (
        <Radio>
          <input id={id} type="radio" required {...field} value={id} />
          {image && (
            <figure>
              <img src={image} />
            </figure>
          )}
          <span></span>
          <label htmlFor={id}>{label}</label>
        </Radio>
      )}
    </FormikField>
  )
}

const Radio = styled.div`
  position: relative;
  display: block;

  > figure {
    position: absolute;
    top: 0;
    left: 0;
    border: 2px solid #b2b2b2;
    border-radius: 2px;
    overflow: hidden;
    z-index: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  > label {
    display: block;
    color: #b2b2b2;
    padding-left: 30px;
    line-height: 19px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 6px;
  }

  > input {
    height: 30px;
    width: 50px;
    position: absolute;
    opacity: 0;
    z-index: 2;
    display: block;
    cursor: pointer;
    z-index: 1;

    &:checked + figure {
      border-color: #fe7e36;
    }
    &:checked ~ label {
      color: #002514;
    }
  }

  > span {
    position: absolute;
    border: 1px solid #000;
    width: 20px;
    height: 20px;
    left: 0;
    top: 5px;
  }
  > input:checked + span::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 3px;
    width: 12px;
    height: 5px;
    background: transparent;
    border: 1px solid #000;
    border-top: none;
    border-right: none;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
`
